import React from "react";
import {AppShortcut} from "../hooks";

type ShortcutCardProps = {
    shortcut: AppShortcut;
    onClick?: () => void;
}

const ShortcutCard = ({shortcut, onClick}: ShortcutCardProps) => {
    return (
        <div className="app-shortcuts-config__shortcut-card" onClick={onClick}>
            <div className="d-flex align-items-center mb-2">
                <div className="app-shortcuts-config__shortcut-card-icon pe-2">
                    <i className={shortcut.icon}></i>
                </div>
                <div className="app-shortcuts-config__shortcut-card-name">
                    {shortcut.name}
                </div>
            </div>
            <small className="text-muted">{shortcut.url}</small>
        </div>
    );
}

export default ShortcutCard;
